(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pj-bag-customizer"] && !Shopify.designMode) return;
  try {
    
function pjSyncBagTemplates(picker) {
  const selectedStyle = picker.querySelector('[data-pj-style-choice]:checked');
  if (!selectedStyle) return;
  const group = selectedStyle.dataset.styleKey;
  const required = picker.dataset.requireTemplate === 'true' && !picker.closest('.pj-bag__form--preview');
  let visibleCount = 0;
  picker.querySelectorAll('.pj-bag__template').forEach((card) => {
    const visible = card.dataset.styleGroup === group;
    const input = card.querySelector('[data-pj-template-choice]');
    card.hidden = !visible;
    input.disabled = !visible;
    input.required = visible && required;
    if (!visible) input.checked = false;
    if (visible) visibleCount += 1;
  });
  const empty = picker.querySelector('[data-pj-template-empty]');
  if (empty) empty.hidden = visibleCount > 0;
}

function pjInitBagTemplates(root) {
  root.querySelectorAll('[data-pj-style-picker]').forEach(pjSyncBagTemplates);
}

function pjActivateBagInfoTab(tab, focusTab = false) {
  const info = tab.closest('[data-pj-info-tabs]');
  if (!info) return;
  info.querySelectorAll('[data-pj-info-tab]').forEach((choice) => {
    const active = choice === tab;
    choice.setAttribute('aria-selected', active ? 'true' : 'false');
    choice.tabIndex = active ? 0 : -1;
    const panel = document.getElementById(choice.getAttribute('aria-controls'));
    if (panel) panel.hidden = !active;
  });
  if (focusTab) tab.focus();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => pjInitBagTemplates(document));
} else {
  pjInitBagTemplates(document);
}

document.addEventListener('change', function(event) {
  if (event.target.matches('[data-pj-style-choice]')) {
    pjSyncBagTemplates(event.target.closest('[data-pj-style-picker]'));
    return;
  }
  if (!event.target.matches('.pj-bag select[name="id"]')) return;
  const section = event.target.closest('.pj-bag');
  const price = section.querySelector('[data-pj-bag-price]');
  const option = event.target.selectedOptions[0];
  if (price && option) price.textContent = option.dataset.price;
});

document.addEventListener('click', function(event) {
  const tab = event.target.closest('[data-pj-info-tab]');
  if (tab) pjActivateBagInfoTab(tab);
});

document.addEventListener('keydown', function(event) {
  const tab = event.target.closest('[data-pj-info-tab]');
  if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  const tabs = Array.from(tab.closest('[data-pj-info-tabs]').querySelectorAll('[data-pj-info-tab]'));
  const index = tabs.indexOf(tab);
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
  event.preventDefault();
  pjActivateBagInfoTab(tabs[next], true);
});

document.addEventListener('shopify:section:load', function(event) {
  pjInitBagTemplates(event.target);
});

document.addEventListener('shopify:block:select', function(event) {
  const infoTab = event.target.closest('[data-pj-info-tab]');
  if (infoTab) {
    pjActivateBagInfoTab(infoTab);
    return;
  }
  const styleCard = event.target.closest('.pj-bag__style');
  if (styleCard) {
    const picker = styleCard.closest('[data-pj-style-picker]');
    const style = styleCard.querySelector('[data-pj-style-choice]');
    if (!picker || !style) return;
    style.checked = true;
    pjSyncBagTemplates(picker);
    return;
  }
  const template = event.target.closest('.pj-bag__template');
  if (!template) return;
  const picker = template.closest('[data-pj-style-picker]');
  const style = Array.from(picker.querySelectorAll('[data-pj-style-choice]')).find((choice) => choice.dataset.styleKey === template.dataset.styleGroup);
  if (!style) return;
  style.checked = true;
  pjSyncBagTemplates(picker);
});

  } catch(e) { console.error(e); }
})();
})();
